<template>
    <div id="matchmaker-projects" class="search-results-container">
        <div class="feature-area feature-area-compact">
            <div class="pageHeader row">
                <div class="col-lg-3 col-sm-12">
                    <div class="title-container">
                        <div class="page-title">Matchmaker Results</div>
                        <div class="sub-title" v-if="searchMeta">
                            {{countOfRecords}} <template v-if="$route.name === 'matchmaker-projects'">Projects</template><template v-else>POs</template>
                        </div>
                    </div>
                </div>
                <div class="col-lg-9 col-sm-12">
                <matchmakerCriteria ref="matchmakerCriteria" v-if="!showPOProjects"/>
                <div v-else class="PO-criteria">
                   <span>Program Official:</span> {{$refs.facets.matchmakerFacetCriteria.program_officials.join(';')}}
                </div>
                </div>
            </div>
            <!-- <div class="sort-note">Results are sorted by <span>Relevance</span></div> -->
            <navigationTabs :alternateTabs="navTabs" ref="navigationTabs" />
        </div>
        <div class="searchResults">
            <div class="adv-results-container" ref="resultsContainer">
                <matchmakerFacets class="" ref="facets"/>
                <div class="dataTable chartDataTable content-with-sidebar">
                    <matchmakerCharts ref="charts" class="chart-container" v-if="!serviceError"/>

                    <div class="field-error-message error-large" v-if="serviceError">
                        Unable to load matchmaker data
                        <div class="error-code">
                        {{serviceError}}
                        </div>
                    </div>
                    <dataTable class="tableContainer dataTable" :table="matchMakerListTable" fromPage="matchmaker" ref="dataTable" v-if="currentView === 'matchmaker-projects' && !serviceError" />
                    <dataTable class="tableContainer dataTable" :table="POListTable" fromPage="matchmaker-po" ref="dataTable" v-if="currentView === 'matchmaker-pos' && !serviceError" />
                </div>
            </div>
        </div>

        <!-- Export -->
        <exportModule ref="exportModule" fromPage="matchmakerResults" />
        <div id="recaptcha-container"></div>
    </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex';
import dataTable from '@/components/global/dataTable.vue';
import navigationTabs from '@/components/global/navigationTabs.vue';
// import Charts from '@/components/global/Charts.vue';
import MatchmakerFacets from '@/components/matchmaker/MatchmakerFacets.vue';
import MatchmakerCriteria from '@/components/matchmaker/MatchmakerCriteria.vue';
import MatchmakerCharts from '@/components/matchmaker/MatchmakerCharts.vue';
import globalMixins from '@/globalMixins';
import projectListMixins from '@/projectListMixins';
import exportModule from  '@/components/global/export.vue';
import FieldError from '@/components/searchFields/FieldError.vue';
import bus from '@/shared/event-bus.js';

export default {
    name: 'matchmakerResults',
    mixins: [globalMixins, projectListMixins],
    components: {
      dataTable,
      navigationTabs,
      MatchmakerFacets,
      MatchmakerCharts,
    //   Charts,
      MatchmakerCriteria,
      exportModule,
      FieldError
    },
    computed: {
        ...mapGetters([
            'searchMeta',
            'searchCriteria',
            'editSearchCriteria',
            'matchmakerResults',
            'matchmakerPOResults'
        ]),
        countOfRecords: function () {
            if (this.searchMeta.total < this.recordsLimit) {
                return window.filters.addCommas(this.searchMeta.total);
            } else {
                return 'Top ' + this.recordsLimit;
            }
        },
        firstUnrevealedRow: function () {
            var test = 0,
                checkForRevealed = (index) => {
                    if (this.rowIsRevealed(index)) {
                        test++;
                        checkForRevealed(test);
                    } else {
                        return test;
                    }
                };

            if (this.revealedRows && this.revealedRows.length > 0) {
                checkForRevealed(test);
            }

            return test;
        }
    },
    data: function () {
        return {
            serverless: false,
            drillDownTable: null,
            recordsLimit: 500,
            currentView: '',
            showPOProjects: false,
            isCaptchaRequested: false,
            captchaValidated: false,
            serviceError: null,
            revealedRows: null,
            matchmakerProjectsChartData: null,
            navTabs: [
                {
                    routePath: 'projects',
                    routeName: 'matchmaker-projects',
                    label: 'Projects'
                },
                {
                    routePath: 'POs',
                    routeName: 'matchmaker-pos',
                    label: 'Program Officials'
                }
            ],
            POListTable: {
                name: 'POListingTable',
                totalCount: 0,
                columns: {
                    ProgramOfficial: {
                        displayName: 'Program Official',
                        fieldName: 'full_name',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isSortable: true,
                        isVisible: true,
                        headerClass: '',
                        cssClass: '',
                        helpText: 'Program Official',
                        callFunctionOnClick: true,
                        dataHelpText: "View all active projects administered by this PO"
                    },
                    IC: {
                        displayName: 'IC',
                        fieldName: 'ic_abbr',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isSortable: true,
                        isVisible: true,
                        headerClass: '',
                        cssClass: '',
                        helpText: 'IC'
                    },
                    ContactInformation: {
                        displayName: 'Contact Information',
                        fieldName: 'po_email',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isSortable: true,
                        isVisible: true,
                        cssClass: '',
                        helpText: 'Contact Information',
                        callFunctionOnClick: true
                    },
                    Projects: {
                        displayName: 'Projects',
                        fieldName: 'projects_counts',
                        isAlternateColumn: false,
                        sortOrder: 'asc',
                        isSortable: true,
                        isVisible: true,
                        headerClass: '',
                        cssClass: '',
                        helpText: 'Projects',
                        callFunctionOnClick: true,
                        dataHelpText: "View PO's similar projects"
                    }
                },
                totalColumns: 4,
                offset: 0,
                limit: 50,
                sortField: "projects_counts",
                sortOrder: 'desc',
                loadingMoreData: false,
                isLoading: false
            },
            criteriaChanged: false
        };
    },
    watch: {
        // reset value if not in correct format
        '$route.name': function (val, oldVal) {
            this.loadInitData(val);
            this.serviceError = false;
            this.isCaptchaRequested = false;
            this.revealedRows = [];
        }
    },
    mounted () {
        if ((this.searchMeta && !this.searchMeta.search_id) || !this.$route.params.search_id) {
            // redirect to home page if no Search ID
            this.$router.push({ path: '/' }).catch(err => {});
        } else {
            this.showCriteria = false;
            // this.drillDownTable = copyData(this.matchMakerListTable);
            window.scrollTo(0, 0);

            this.loadInitData(this.$route.name);
            this.initCaptcha();
        }
        bus.$on('matchmaker:updateChartFacet', () => {
            this.updateChartFacets();
        });
        this.setFullscreen(true);
        setTimeout(() => {
            bus.$emit('update:resize');
        }, 1);
    },
    methods: {
        ...mapActions([
            'setFullscreen',
            'setEditSearchResultsFlag',
            'setLookup',
            'setSearchMode',
            'setMatchmakerResults',
            'setMatchmakerPOResults'
        ]),
        rowIsRevealed (rowIndex) {
            return this.revealedRows.indexOf(rowIndex) !== -1;
        },
        initCaptcha () {
            this.revealedRows = [];
            grecaptcha.ready(() => {
                grecaptcha.render('recaptcha-container', {
                    sitekey: '6LdpQbMUAAAAAJZN02xaecwPWh7x6aQo3BDVDR7x',
                    size: 'invisible',
                    callback: this.loadEmails
                });
            });
        },
        resetCaptcha () {
            this.isCaptchaRequested = false;
            this.captchaValidated = false;
            this.revealedRows = [];
            grecaptcha.reset();
            this.serviceError = false;
        },
        loadInitData (routeName) {
            var facetToQueryStr = '';

            this.currentView = routeName;
            this.setSearchMeta(null);
            this.$nextTick(() => {
                if (routeName === 'matchmaker-pos') {
                    if (this.showPOProjects) {
                        this.resetPOs();
                    }
                    if (!this.matchmakerPOResults) {
                        this.POListTable.isLoading = true;
                        if (this.$route.query.sort_field) {
                            this.POListTable.sortField = this.$route.query.sort_field;
                        } else {
                            this.POListTable.sort_field = '';
                        }
                        if (this.$route.query.sort_order) {
                            this.POListTable.sortOrder = this.$route.query.sort_order;
                        } else {
                            this.POListTable.sort_field = '';
                        }
                        this.getMatchmakerPOResults(this.criteriaChanged, false);
                    } else {
                        this.setSearchMeta(this.$store.state.matchmakerPOResults.meta);
                    }
                    this.$refs.dataTable.initTableData();
                    facetToQueryStr = this.$refs.facets.generateQueryString();
                    this.POListTable.sortOrder = 'desc';
                    this.POListTable.sortField = 'projects_counts';
                } else {
                    if (!this.matchmakerResults) {
                        this.matchMakerListTable.isLoading = true;
                        if (this.$route.query.sort_field) {
                            this.matchMakerListTable.sortField = this.$route.query.sort_field;
                        } else {
                            this.matchMakerListTable.sort_field = '';
                        }
                        if (this.$route.query.sort_order) {
                            this.matchMakerListTable.sortOrder = this.$route.query.sort_order;
                        } else {
                            this.matchMakerListTable.sort_field = '';
                        }
                        this.getMatchmakerSearchResults(this.criteriaChanged, false);
                    } else {
                        this.setSearchMeta(this.$store.state.matchmakerResults.meta);
                    }
                    this.$refs.dataTable.initTableData();
                    facetToQueryStr = this.$refs.facets.generateQueryString();
                    this.matchMakerListTable.sortOrder = 'desc';
                    this.matchMakerListTable.sortField = 'match_score';
                }
                this.$router.push({ query: facetToQueryStr}).catch(err => {});
            });
        },
         updateChartFacets () {
            if (!this.$store.state.matchmakerFacetData) {
                this.$refs.facets.getMatchmakerFacets(false);
            }
            if (!this.matchmakerProjectsChartData) {
                this.getMatchmakerProjectsChartData();
            }
        },
        captchaTest () {
            grecaptcha.execute();
        },
        loadEmails (token) {
            this.POListTable.isLoading = true;
            this.isCaptchaRequested = true;
            window.getMatchmakerPOResults({
                search_id: this.$route.params.search_id,
                criteria: {
                    recaptcha: token
                }
            }, this.updateMatchmakerPOResults);
        },
        setProjectPageNumber (loadAllData) {
            if ((this.$store.state.searchMeta.total > this.matchMakerListTable.offset + this.matchMakerListTable.limit) && (this.recordsLimit > this.matchMakerListTable.offset + this.matchMakerListTable.limit)) {
                this.matchMakerListTable.offset += this.matchMakerListTable.limit;
                if (loadAllData) {
                    this.matchMakerListTable.limit = 500 - this.matchMakerListTable.offset;
                }
                this.getMatchmakerSearchResults(false, false);
            } else {
                this.matchMakerListTable.loadingMoreData = false;
            }
        },
        setSortDetails ($event, selectedSortColumn) {
            // this.isLoading = true;
            // this.setMatchmakerSortDetails(selectedSortColumn);
            var tableData,
                tableObj,
                facetToQueryStr,
                totalMaxRecords,
                dbSortField = this.getFieldNameFromSettings(selectedSortColumn),
                selectedSortField = selectedSortColumn.subField ? selectedSortColumn.fieldName + '[0].' + selectedSortColumn.subField : selectedSortColumn.fieldName;

            if (this.$route.name === 'matchmaker-projects') {
                totalMaxRecords = this.$store.state.matchmakerResults.meta.total > 500 ? 500 : this.$store.state.matchmakerResults.meta.total;
                tableData = this.$store.state.matchmakerResults.results;
                tableObj = this.matchMakerListTable;                
                if (totalMaxRecords > 100 && tableObj.offset === 0) {
                    this.setProjectPageNumber(true);
                    return;
                }
            } else {
                tableData = this.$store.state.matchmakerPOResults.results;
                tableObj = this.POListTable;
            }
			tableObj.selectedSortColumn = selectedSortField;
            tableObj.isLoading = true;
            if (tableObj.sortField === dbSortField) {
                tableObj.sortOrder = tableObj.sortOrder === 'asc' ? 'desc' : 'asc';
            }
            tableObj.sortField = dbSortField;
            var sortFieldName = tableObj.selectedSortColumn.fieldName;

            if (tableObj.selectedSortColumn.sortFieldName) {
                sortFieldName = tableObj.selectedSortColumn.sortFieldName;
            } else if (tableObj.selectedSortColumn.subField) {
                sortFieldName = tableObj.selectedSortColumn.subField;
            }
            this.$refs.dataTable.tableMeta.sort_field = copyData(sortFieldName);

            this.$refs.dataTable.tableData = _.orderBy(tableData, selectedSortField, tableObj.sortOrder);

            gtag('event','Click', {
				'event_category': 'Matchmaker - Sorting',
				'event_label': this.$route.name + ' table - ' + selectedSortColumn.fieldName + ' - ' +  tableObj.sortOrder,
				'value': this.$route.name + ' table - ' + selectedSortColumn.fieldName + ' - ' +  tableObj.sortOrder
			});	

            setTimeout(function () {
                if (tableData.length > 0) {
                   window.fixHeaders('scrollTable');
                }
                tableObj.isLoading = false;
            }, 11);
        },
        exportData (selectedFieldsToExport, callback) {
            var searchParam,
                criteria = copyData(this.$refs.facets.matchmakerFacetCriteria);

            // if (!criteria['publication_years'] || (criteria['publication_years'] && criteria['publication_years'].length === 0)) {
            //     criteria['publication_years'] = this.$refs.facets.publicationsFacetData.facets[0].values.map((item) => {
            //         return item.value;
            //     });
            // }
            searchParam = {
                "search_id": this.$route.params.search_id,
                "facet_filters": criteria,
                "export_fields": selectedFieldsToExport,
                "file_format": this.$refs.exportModule.exportFileFormat,
                "sort_field": this.matchMakerListTable.sortField,
                "sort_order": this.matchMakerListTable.sortOrder,
                "criteria": this.$refs.exportModule.exportSearchCriteria ?  this.exportCriteria : null
            }
            this.getExportFile(searchParam, callback);
        },
        scrollToResultsTop () {
            let resultsOffsetTop = this.getResultsContainerOffsetTop();

            // only scroll up if user view is scrolled below top of table
            if (window.pageYOffset > resultsOffsetTop) {
                window.scrollTo(0, this.getResultsContainerOffsetTop());
            }
        },
        getResultsContainerOffsetTop () {
            return this.$refs.resultsContainer ? this.$refs.resultsContainer.offsetTop : 0;
        },
        takeColAction (data, fieldName, rowIndex) {
            this.revealedRows.push(rowIndex);
            this.captchaTest();
        },
        loadDrillDownTableData (data, fieldName) {
            if (fieldName !== 'po_email') {
                this.setSearchMeta(null);
                this.showPOProjects = true;
                var facetsSelected = copyData(this.$refs.facets.matchmakerFacetCriteria);
                facetsSelected['program_officials'] = [data['full_name']];
                this.$refs.navigationTabs.currentPath = 'matchmaker-projects';
                this.$router.push({ path: 'projects' }).catch(err => {});
                this.$refs.facets.updateSearch(facetsSelected, 100);
            } else {
                this.captchaTest();
            }
        },
        goTo (path) {
            this.resetPOs();
            this.$refs.navigationTabs.currentPath = 'matchmaker-pos';
            this.$router.push({ path: 'POs' }).catch(err => {});
        },
        resetPOs () {
            var facetsSelected = copyData(this.$refs.facets.matchmakerFacetCriteria);
            facetsSelected['program_officials'] = [];
            this.showPOProjects = false;
            this.$refs.facets.updateSearch(facetsSelected, 100);
        },
        getMatchmakerProjectsChartData () {
            var searchCriteriaTemp = {
                    search_id: this.$route.params.search_id,
                    cache_id: this.$store.state.matchmakerResults ? this.$store.state.matchmakerResults.meta.properties.CacheId : null,
                    facet_filters: this.matchmakerFacetCriteria
                };

            this.sendChartsRequest(searchCriteriaTemp, this.handleChartsData);
        },
        sendChartsRequest (params, callback) {
            var xhr = new XMLHttpRequest(),
                serializedParams,
                url,
                data,
                requestType = 'POST';

            serializedParams = JSON.stringify(params);

            url = '/services/Matchmaker/Charts';

            xhr.open(requestType, url, true);
            xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
            xhr.onload = () => {
				gtag('event','timing_complete', {
					'name' : url,
					'value' : 'search-charts',
					'event_category' : 'Search Charts Service'
				});
				
                if (xhr.status === 200) {
                    data = JSON.parse(xhr.response);

                    if (callback) {
                        callback(data);
                    }
                } else {
                    if (callback) {
                        callback(xhr);
                    }
                }
            };

            xhr.onerror = () => {
                if (callback) {
                    callback(xhr);
                }
            };            

            xhr.send(serializedParams);
        },
        handleChartsData (data) {
            this.matchmakerProjectsChartData = data;
            // var self = this,
            //     tempFacetIndex,
            //     isExists = false,
            //     orgData = copyData(data);

            // this.facetLoader = false;
            // if (!data.status) {
            //     data = copyData(data);

            //     this.setMatchmakerFacetData(data);

            //     if (!this.matchmakerFacetCriteria) {
            //         this.setMatchmakerFacetCriteria(data);
            //         this.$parent.parseFacetFiltersFromURL();
            //     } else {
            //         for (let item in this.facetCriteriaOrg) {
            //             for (let i = 0; i < orgData.facets.length; i++) {
            //                 if (orgData.facets[i].name === item) {
            //                     tempFacetIndex = i;
            //                     break;
            //                 }
            //             }
            //             if (tempFacetIndex) {
            //                 for (let i = 0; i < this.facetCriteriaOrg[item].length; i++) {
            //                     isExists = false;
            //                     orgData.facets[tempFacetIndex].values.filter((val) => {
            //                         if (val && this.facetCriteriaOrg[item][i] && val.value === this.facetCriteriaOrg[item][i].value) {
            //                             isExists  = true;
            //                             return;
            //                         }
            //                     });
            //                     if (!isExists && this.facetCriteriaOrg[item][i]) {
            //                         orgData.facets[tempFacetIndex].values.push({
            //                             value: this.facetCriteriaOrg[item][i].value,
            //                             display: this.facetCriteriaOrg[item][i].display,
            //                             count: 0
            //                         });
            //                     }
            //                 }
            //             }
            //         }
            //         data = copyData(orgData);
            //         this.setMatchmakerFacetData(data);
            //     }
            // } else {
            //     this.facetError = true;
            // }

            // if (this.matchmakerFacetCriteria['is_active_projects'] === undefined) {
            //     this.updateMatchmakerFacetCriteria(this.passedFacetCriteria);
            // }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';
.feature-area {
    .search-results-section {
        width: 300px;
    }
}
</style>
